import React, { useEffect } from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Formik, Form, Field } from 'formik'
import _map from 'lodash/map'
import modalStyle from '../../../_common/core/modalStyle'
import {
  get_email_templates,
  get_event,
  get_event_tables,
  get_event_tickets,
} from '../../../_common/core/selectors'
import { FETCH_EVENT_TICKETS } from '../../../_common/redux/tickets/actions'
import { FETCH_EMAIL_TEMPLATES } from '../../../_common/redux/emailtemplates/actions'
import {
  SEND_INVITATIONS,
  CANCEL_INVITATION,
  CREATE_INVITATION,
} from '../../../_common/redux/invitation/actions'

import { showAxiosError, showSuccessMessage } from '../../utils/messenger'
import Button from '../../_library/Button'
import { requiredValidator } from '../../../_common/core/validation'
import { RichTextAreaField, SelectField, SimpleField } from '../../formik/Fields'
import { ENV } from '../../constants/env'

const InvitationModal = props => {
  const {
    event,
    isModalOpen,
    closeModal,
    FETCH_EVENT_TICKETS,
    SEND_INVITATIONS,
    FETCH_EMAIL_TEMPLATES,
    selectedSubmission,
    emailTemplatesOption,
  } = props

  useEffect(() => {
    if (event?.id) {
      try {
        FETCH_EVENT_TICKETS(event.id)
        FETCH_EMAIL_TEMPLATES(event.id)
      } catch (error) {
        showAxiosError(error)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event])

  const initialValues = {
    subject: '',
    body: '',
    recipient: {
      first_name: selectedSubmission?.customer_first_name || '',
      last_name: selectedSubmission?.customer_last_name || '',
      email: selectedSubmission?.email || '',
      maxQuantity: 1,
      maxUses: 1,
    },
  }

  const handleSubmitForm = async (values, { setSubmitting }) => {
    try {
      await SEND_INVITATIONS(event.id, {
        body: values.body,
        subject: values.subject,
        recipients: [values.recipient],
      })

      showSuccessMessage('Successfully sent!')
      closeModal()
    } catch (error) {
      const errMsg = error.errors[0].details
      showAxiosError(error.errors[0], errMsg, 3)
    }
  }

  return (
    <Modal
      className="modal-dialog modal-trans modal-lg customer-form-modal"
      isOpen={isModalOpen}
      onRequestClose={closeModal}
      style={modalStyle}
      contentLabel="Create Custom Form"
    >
      <div className="modal-dialog modal-lg" style={{ overflow: 'visible' }}>
        <div className="modal-content">
          <div className="modal-header">
            <h2>Send Invitation</h2>
          </div>
          <div className="modal-body">
            <Formik
              initialValues={initialValues}
              onSubmit={async (values, { setSubmitting, setErrors }) => {
                handleSubmitForm(values, { setSubmitting, setErrors })
              }}
              validateOnMount={false}
              // validate={valuesData => validateForm(valuesData)}
              enableReinitialize
            >
              {({ values, errors, handleSubmit, setFieldValue }) => (
                <Form>
                  <div
                    className="customer-form-guest-tickets"
                    style={{ display: 'flex', flexDirection: 'column', gap: 20 }}
                  >
                    <div className="row">
                      <div className="col-sm-6 col-xs-12">
                        <Field
                          name="recipient.email"
                          label="Email"
                          type="email"
                          component={SimpleField}
                          validate={requiredValidator()}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6 col-xs-12">
                        <Field
                          name="recipient.first_name"
                          label="First name"
                          component={SimpleField}
                          validate={requiredValidator()}
                        />
                      </div>
                      <div className="col-sm-6 col-xs-12">
                        <Field
                          name="recipient.last_name"
                          label="Last name"
                          component={SimpleField}
                          validate={requiredValidator()}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6 col-xs-12">
                        <Field
                          name="emailTemplate"
                          label="Select from Email Templates"
                          component={SelectField}
                          options={emailTemplatesOption}
                          onSelect={option => {
                            if (option?.data) {
                              setFieldValue('subject', option.data.subject)
                              setFieldValue('body', option.data.body)
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xs-12">
                        <Field
                          name="subject"
                          label="Subject"
                          component={SimpleField}
                          validate={requiredValidator()}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xs-12">
                        <Field
                          name="body"
                          label="Invitation Content"
                          component={RichTextAreaField}
                          validate={requiredValidator()}
                          baseurl={ENV.CDN_URL}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6 col-xs-12">
                        <Field
                          name="recipient.maxQuantity"
                          label="Maximum number of tickets"
                          component={SelectField}
                          options={_map(new Array(50), (e, i) => ({ value: 50 - i, label: 50 - i }))}
                          validate={requiredValidator()}
                        />
                      </div>
                      <div className="col-sm-6 col-xs-12">
                        <Field
                          name="recipient.maxUses"
                          label="Maximum number of transactions"
                          component={SelectField}
                          options={_map(new Array(50), (e, i) => ({ value: 50 - i, label: 50 - i }))}
                          validate={requiredValidator()}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer" style={{ margin: '20px -15px 0px' }}>
                    <div className="btn-toolbar btn-toolbar-right">
                      <Button className="btn btn-default btn-success" type="submit">
                        Send
                      </Button>
                      <Button className="btn btn-default btn-cancel" type="button" onClick={closeModal}>
                        Cancel
                      </Button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </Modal>
  )
}

const mapStateToProps = state => {
  const event = get_event(state)
  const tickets = get_event_tickets(state)
  const tables = get_event_tables(state)
  const emailTemplates = get_email_templates(state)

  return {
    user: state.auth.user,
    event,
    tickets,
    tables,
    emailTemplates,
  }
}

const CustomerFormInvitationModal = connect(mapStateToProps, {
  FETCH_EVENT_TICKETS,
  SEND_INVITATIONS,
  CANCEL_INVITATION,
  FETCH_EMAIL_TEMPLATES,
  CREATE_INVITATION,
})(withRouter(InvitationModal))

export default CustomerFormInvitationModal
